import MplusLogo from 'shared/icons/mplus_webp.webp'

import s from './styles.module.scss'

export const MplusIcon = () => {
  return (
    <img
      src={MplusLogo}
      alt="mplus icon"
      className={s.logo}
    />
  )
}
